import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadCategoriesBrands, getCsvFeaturedManufacturerModel } from '../app/store/actions/featuredManufacturer';
import UploadFilesComponent from '../components/upload';
import FeaturedManufactureImportErrors from '../components/upload/FeaturedManufactureImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadFeaturedManufacturesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadFeaturedManufactures(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvFeaturedManufacturerModel();
  }

  goBack = () => {
    history.push(ROUTES.FEATURED_MANUFACTURE);
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importFeaturedManufactures" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importText1" /></strong></p>
            <p><Translate value="importText2" /></p>
            <p><Translate value="importText3" /></p>
            <p><Translate value="importText4" /></p>
            <p><Translate value="manufacturerImportText1" /></p>
            <p><Translate value="manufacturerImportText2" /></p>
          </div>


          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<FeaturedManufactureImportErrors errors={errors} />}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadFeaturedManufactures: file => dispatch(uploadCategoriesBrands(file)),
  getCsvFeaturedManufacturerModel: () => dispatch(getCsvFeaturedManufacturerModel()),
});

export default connect(null, mapDispatchToProps)(UploadFeaturedManufacturesPage);
